import Link from "next/link";
import { ARCHIVES_URL } from "../../../utils/constants/websiteUrls";

const PastSeasonCard = ({ season }) => {
  return <>
    <Link key={season.name} href={`${ARCHIVES_URL}/${season.slug}`}>

      <div className="flex justify-center items-center p-4 space-x-4 rounded-md md:space-x-6 text-center hover:cursor-pointer bg-gray-50 hover:bg-gray-900 text-gray-900 hover:text-gray-50 border-2 border-gray-300 hover:border-gray-900">
        <div className="flex flex-col justify-center">
          <p className="text-sm font-medium">{season.name}</p>
        </div>
      </div>

    </Link>
  </>;
};

export default PastSeasonCard;
